import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ExpenseListView } from '../components/expenses/ExpenseListView';

/**
 * Standalone expenses route. When mounted under /events/:eventId/expenses
 * it pre-scopes the list by event; otherwise shows all expenses with the
 * built-in event-filter dropdown.
 *
 * All UI (filters, summary, action buttons, modals) lives in ExpenseListView,
 * so this page is intentionally a thin shell — the same component renders on
 * the event detail page and the vendor detail page.
 */
export function ExpensesPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const { user: currentUser } = useAuth();

  if (!currentUser) return null;

  const isEventScoped = !!eventId;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          {isEventScoped ? 'Event Expenses' : 'All Expenses'}
        </h1>
      </div>

      <ExpenseListView
        entityType={isEventScoped ? 'EVENT' : undefined}
        entityId={eventId}
        currentUser={currentUser}
      />
    </div>
  );
}
